(function () {
  window.addEventListener("DOMContentLoaded", (event) => {
    const seeMore = qs('#js-image-banner__seemore');
    const description = qs('#js-image-banner__description');
    const text = qs('#js-image-banner__description-text');

    const lineHeight = parseFloat(getComputedStyle(description).lineHeight);
    const maxHeight = lineHeight * 4.8; 

    seeMore.addEventListener('click', function(e) {
      text.classList.toggle('line-clamp-4');
      if (e.target.dataset.seemore == 'true') {
        e.target.dataset.seemore = 'false';
        e.target.innerText = 'voir moins';
      } else {
        e.target.dataset.seemore = 'true';
        e.target.innerText = 'voir plus'
      }
    });

    if (text.clientHeight > maxHeight) {
      text.classList.add('line-clamp-4');
      description.style.maxHeight = 'none';
      seeMore.style.display = 'inline-block';
    } else {}
  });
})();
